import { render, staticRenderFns } from "./TemplateCategoriesBox.vue?vue&type=template&id=120a6af6&lang=pug&"
import script from "./TemplateCategoriesBox.vue?vue&type=script&lang=ts&"
export * from "./TemplateCategoriesBox.vue?vue&type=script&lang=ts&"
import style0 from "./TemplateCategoriesBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports